import { WinSummary } from "../Abstract/WinnebagoSummary";
import { WinPublicService } from "../../Services/Winnebago/WinPublicService";
import  displayWinParcelInfo  from '../../SummaryTools/Winnebago/displayParcelInfo.js'

export default class WinPublicSummary extends WinSummary {
    constructor(Pin) {
        super(Pin, PublicPropertySearchService, 'https://maps.wingis.org/public/rest/services/Orthos2024/MapServer', new WinPublicService());
        
        this.#basicInit();

    }

    title = "Winnebago Public Summary"; 

    async #basicInit () {
        await super.basicInit();
        this.summaryDivs.basicParcelInfo.innerHTML = displayWinParcelInfo(this.parcelInfo);

    }


}
